import React, { useContext, useRef, useEffect } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import SwiperCore, { Autoplay } from "swiper/core"; // Import Swiper Autoplay
import Sidebar from "../../img/panier1.jpg";
import Ecommerce from "../../img/natif.jpg";
import HOC from "../../img/figma.jpg";
import MusicApp from "../../img/flixter.jpg";
import { themeContext } from "../../Context";

SwiperCore.use([Autoplay]); // Enable Swiper Autoplay

const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const swiperRef = useRef(null);

  useEffect(() => {
    const swiperInstance = swiperRef.current.swiper;

    // Enable Autoplay after Swiper initialization
    swiperInstance.autoplay.start();
  }, []);

  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span style={{ color: darkMode ? "white" : "" }}>Recent Projects</span>
      <span>Portfolio</span>

      {/* slider */}
      <Swiper
        spaceBetween={20}
        slidesPerView={3}
        grabCursor={true}
        className="portfolio-slider"
        ref={swiperRef}
        autoplay={{ delay: 3000, disableOnInteraction: false }} // Autoplay with a 3-second delay
        loop={true} // Enable infinite loop
      >
        <SwiperSlide>
          <img src={HOC} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Sidebar} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Ecommerce} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={MusicApp} alt="" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Portfolio;
